import { render, staticRenderFns } from "./illustration.vue?vue&type=template&id=5bbc5b4c&scoped=true"
import script from "./illustration.vue?vue&type=script&lang=js"
export * from "./illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc5b4c",
  null
  
)

export default component.exports